import dayjs from "dayjs";

export const generateOrderCookieId = () => {
  const date = dayjs().format("YYYYMMDDHmssss");
  const cookie =
    date +
    Math.floor(9999999 + Math.random() * 9999999) +
    Math.floor(9999999 + Math.random() * 9999999) +
    Math.floor(9999999 + Math.random() * 9999999);

  return cookie;
};
